import CashAdjustment from 'src/models/cash/CashAdjustment'
import CashCount from 'src/models/cash/CashCount'
import CashDeposit from 'src/models/cash/CashDeposit'
import CashSession from 'src/models/cash/CashSession'
import Model, { JsonArray } from 'src/models/model'

export default class CashReconciliation extends Model {
  static name = 'CashReconciliation'

  static noId = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.PointOfSale, Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.fields = {
      cashCounts: {
        type: [CashCount]
      },
      cashSessions: {
        type: [CashSession]
      },
      cashAdjustments: {
        type: [CashAdjustment]
      },
      cashDeposit: {
        type: CashDeposit
      },
      tips: {
        type: JsonArray
      },
      accountingDayLocked: {
        type: Boolean,
        output: true,
        default: false
      }
    }

    this.queries = {
      cashReconciliationByDate: {
        arguments: {
          date: {
            type: String,
            required: true
          }
        },
        results: {
          cashReconciliation: CashReconciliation
        }
      }
    }
  }
}
